import { ReportHandler } from 'web-vitals';

type ImportWebVitals = () => Promise<{
  getCLS: (cb: ReportHandler) => void;
  getFID: (cb: ReportHandler) => void;
  getFCP: (cb: ReportHandler) => void;
  getLCP: (cb: ReportHandler) => void;
  getTTFB: (cb: ReportHandler) => void;
}>;

const defaultImportWebVitals: ImportWebVitals = () => import('web-vitals');

const reportWebVitals = (
  onPerfEntry?: ReportHandler,
  importWebVitals: ImportWebVitals = defaultImportWebVitals
) => {
  if (typeof onPerfEntry === 'function') {
    importWebVitals().then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
